export type SynthesesMetricTone =
  | "sand"
  | "olive"
  | "teal"
  | "blue"
  | "violet"
  | "rose"
  | "slate";

export function getSynthesesMetricToneClasses(tone: SynthesesMetricTone) {
  switch (tone) {
    case "sand":
      return {
        card: "border-[#ff0000]/25 bg-[#ff0000]/8",
        label: "text-[#c81e1e]",
        value: "text-[#a51616]",
        iconWrap: "bg-[#ff0000]/12 text-[#c81e1e]",
        meta: "text-[#b84c4c]",
      };
    case "olive":
      return {
        card: "border-verdeogreen/25 bg-verdeogreen/10",
        label: "text-verdeogreen",
        value: "text-verdeogreen",
        iconWrap: "bg-verdeogreen/15 text-verdeogreen",
        meta: "text-verdeogreen/80",
      };
    case "teal":
      return {
        card: "border-[#a1560b]/25 bg-[#a1560b]/10",
        label: "text-[#8b4a09]",
        value: "text-[#7a4108]",
        iconWrap: "bg-[#a1560b]/12 text-[#8b4a09]",
        meta: "text-[#8b4a09]/80",
      };
    case "blue":
      return {
        card: "border-verdeoblue/25 bg-verdeoblue/10",
        label: "text-verdeoblue",
        value: "text-verdeoblue",
        iconWrap: "bg-verdeoblue/15 text-verdeoblue",
        meta: "text-verdeoblue/80",
      };
    case "violet":
      return {
        card: "border-[#425e1a]/25 bg-[#425e1a]/10",
        label: "text-[#425e1a]",
        value: "text-[#344816]",
        iconWrap: "bg-[#425e1a]/12 text-[#425e1a]",
        meta: "text-[#425e1a]/80",
      };
    case "rose":
      return {
        card: "border-verdeoblue/25 bg-verdeoblue/8",
        label: "text-slate-800",
        value: "text-slate-900",
        iconWrap: "bg-verdeoblue/12 text-verdeoblue",
        meta: "text-slate-600",
      };
    case "slate":
    default:
      return {
        card: "border-slate-200 bg-white",
        label: "text-slate-600",
        value: "text-slate-900",
        iconWrap: "bg-slate-100 text-slate-500",
        meta: "text-slate-500",
      };
  }
}
